import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
          <g>
            <path d="M0 0H24V24H0z" />
            <path
              fill="#818c99"
              fillRule="nonzero"
              d="M5.895 5C4.855 5 4 5.89 4 6.969V17.03C4 18.111 4.856 19 5.895 19h12.21c1.04 0 1.895-.89 1.895-1.969V6.97C20 5.889 19.144 5 18.105 5H5.895zm0 1.313h12.21c.357 0 .632.285.632.656V17.03c0 .37-.275.657-.632.657H5.895c-.357 0-.632-.286-.632-.657V6.97c0-.37.275-.657.632-.657zm1.263 5.03c-.349 0-.632.295-.632.657 0 .362.283.656.632.656.349 0 .631-.294.631-.656 0-.362-.282-.656-.631-.656z"
              transform="rotate(-90 12 12)"
            />
          </g>
        </g>
      </svg>
    </>
  );
};
